import { __decorate } from "tslib";
import React from 'react';
import { observer } from 'mobx-react';
import noop from 'lodash/noop';
import omit from 'lodash/omit';
import Slider from '../../../lib/slider';
import { NumberField } from '../number-field/NumberField';
let Range = class Range extends NumberField {
    renderWrapper() {
        return (React.createElement("label", Object.assign({ key: "wrapper" }, omit(this.getWrapperProps(), ['style'])), this.renderTrack()));
    }
    renderTrack() {
        const { props: { dataSet, onChange = noop, ...otherProps }, prefixCls, } = this;
        if (this.readOnly) {
            otherProps.value = this.value;
        }
        if (dataSet) {
            let props = {};
            if (otherProps.name) {
                const field = dataSet.getField(otherProps.name);
                if (field) {
                    props = { ...field.getProps() };
                }
                const { current } = dataSet;
                if (current) {
                    props.value = current.get(otherProps.name);
                }
            }
            return (React.createElement(Slider, Object.assign({ prefixCls: prefixCls }, otherProps, props, { onChange: (value) => {
                    this.setValue(value);
                    onChange(value);
                } })));
        }
        return (React.createElement(Slider, Object.assign({ prefixCls: prefixCls }, otherProps, { onChange: onChange })));
    }
};
Range.displayName = 'Range';
Range.defaultProps = {
    ...NumberField.defaultProps,
    suffixCls: 'range',
    min: 0,
    step: 1,
    max: 100,
    vertical: false,
    dots: false,
    marks: {},
    included: true,
    range: false,
    tipFormatter: null,
};
Range = __decorate([
    observer
], Range);
export default Range;
